import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6734c7e8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734c7e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6734c7e8')) {
      api.createRecord('6734c7e8', component.options)
    } else {
      api.reload('6734c7e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6734c7e8&scoped=true&", function () {
      api.rerender('6734c7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceLCLShare/index.vue"
export default component.exports